import { initAuthApi } from './init-auth-api.ts'
import { initGraphql } from './init-graphql.ts'
import { initRevolugoDesignSystem } from './init.ts'

import type { RevolugoDesignSystemConfig } from '../composables/use-config.ts'
import type { App } from 'vue'

export { configureAuthApiUrl } from '#services/api-client'

export function initRevolugoDesignSystemWithClients(
  app: App,
  options?: RevolugoDesignSystemConfig,
) {
  initRevolugoDesignSystem(app, options)
  initGraphql(app)
  initAuthApi(app)
}
